export default __webpack_public_path__ + "static/metamodel-c6600d20ce27484554176a4e23b9a9c9.jpg";